import { createContext } from "react";

export const Text = createContext();